export const samlKeys = {
  getIdp: ['get-idp']
};
